export default __webpack_public_path__ + "./images/va.52a7ecb9.png";